import { useState, useEffect } from "react";

function Loaderbar() {
    const [start, setStart] = useState(false);
    useEffect(() => {
        setTimeout(() => setStart(true), 10);
    }, []);
    return (
        <div className="fixed top-0 left-0 w-full h-full flex items-center justify-center bg-white z-50 dark:bg-[#121519]">
            <div
                className={`absolute top-0 left-0 h-[3px] bg-[#0ae440] transition-all duration-500 ${start ? "w-full" : "w-0"
                    }`}
            />
            <img src="https://i.gifer.com/ZZ5H.gif" alt="loading" className="w-16 h-16" />
        </div>
    );
}

export default Loaderbar